// project imports
import { getIriFromObj } from 'utils/processors';
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import {
    processEntityInput as processEntityInputSafeDeleter,
    processEntityOutput as processEntityOutputSafeDeleter
} from 'store/serializers/fragments/safe-deleter';
import {
    processEntityInput as processEntityInputPhoneNumber,
    processEntityOutput as processEntityOutputPhoneNumber
} from 'store/app/common/phone-number';
import { processEntityInput as processEntityInputContact, processEntityOutput as processEntityOutputContact } from 'store/app/crm/contact';
import {
    processEntityInput as processEntityInputLocation,
    processEntityOutput as processEntityOutputLocation
} from 'store/app/common/location';

export const processEntityInput = (values) => ({
    ...values,
    ...processEntityInputMain(values),
    ...processEntityInputSafeDeleter(values),
    mainPhoneNumbers: values?.mainPhoneNumbers
        ?.map((phoneNumber) => processEntityInputPhoneNumber(phoneNumber))
        ?.sort((pn1, pn2) => (pn1.createdAt < pn2.createdAt ? 1 : -1)),
    locations: values?.locations
        ?.map((location) => processEntityInputLocation(location))
        ?.sort((l1, l2) => (l1.createdAt < l2.createdAt ? 1 : -1)),
    contacts: values?.contacts
        ?.map((contact) => processEntityInputContact(contact))
        ?.sort((c1, c2) => (c1.createdAt < c2.createdAt ? 1 : -1))
});

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    ...processEntityOutputSafeDeleter(values),
    partnershipType: 'partnershipType' in (values || {}) ? getIriFromObj(values.partnershipType) : undefined,
    mainPhoneNumbers:
        'mainPhoneNumbers' in (values || {}) && Array.isArray(values.mainPhoneNumbers)
            ? values.mainPhoneNumbers.map((phoneNumber) => processEntityOutputPhoneNumber(phoneNumber))
            : undefined,
    locations:
        'locations' in (values || {}) && Array.isArray(values.locations)
            ? values.locations.map((location) => processEntityOutputLocation(location))
            : undefined,
    contacts:
        'contacts' in (values || {}) && Array.isArray(values.contacts)
            ? values.contacts.map((contact) => processEntityOutputContact(contact))
            : undefined
});
